var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIris(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: "1em",
    height: "1em"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iris_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 96.097,
    y1: 902.503,
    x2: 876.077,
    y2: 122.523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3554"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.5 724.7L74.1 750.5l134.7-310.8-137.9-188 335.3-38.2L497.3 4l199.6 271.3 229.4-25.8-134.1 309.3 136.9 186.7-333.6 38L503 996 303.5 724.7zm95.3-20.6c-8.8 4.3-18.2 7.9-27.9 10.6l-8.8 2.4 129.3 175.8 45.9-105.6-8.3-1.1c-45.2-5.7-86.3-30.1-112.8-66.7l-12.9-17.8-4.5 2.4zm-45-159.4L458.1 689c21.2 29.3 55.5 46.8 91.7 46.8 4.2 0 8.4-.2 12.5-.7l272.2-31-108.4-147.9c-5.4-7.3-11.6-13.9-18.5-19.7l-6.4-5.3-77.6 175.3-135-178.7-134.8 16.9zm4.5-175.7c-40.4 4.3-75.6 30.2-91.8 67.6L157.2 688.9l181.6-20.4c9-1 17.8-3.1 26.3-6.2l7.8-2.9-112.4-155.2 221.6-28.1 52.7-125.9L358.3 369zm171.5 127.3L611.9 605 662 491.9l22-49.8c16.5-37.3 11.8-80.8-12.4-113.6L508.9 107.1l-73.2 168.2c-3.6 8.3-6.2 17-7.8 26l-1.4 8.2 189.9-20.1-86.6 206.9zm199.5-172.4l3.2 7.7c17.6 42.1 17.2 90.1-1.2 131.6l-8.9 20 4.3 2.9c8.2 5.5 15.9 11.9 23 19l6.5 6.4L843.1 311l-113.8 12.9zm-563.8-30.8l69.2 94.4 5.1-6.6c27.5-35.7 68.8-58.9 113.1-63.6l21.7-2.3.4-5.3c.7-10.9 2.6-21.8 5.5-32.4l2.5-9-217.5 24.8z",
    fill: "url(#iris_svg__a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iris_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 181.197,
    y1: 987.603,
    x2: 961.178,
    y2: 207.623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3554"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451.6 1000c-144-13.9-273.4-88.8-358.1-207.5l58-6.5c9.6 11.8 19.8 23.1 30.3 33.7 62.9 63.2 141.6 105.8 227.9 123.4l41.9 56.9z",
    fill: "url(#iris_svg__b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iris_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 403.727,
    y1: 1210.132,
    x2: 1183.707,
    y2: 430.152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3554"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M572.4 946.3c93.4-15.1 178.3-58.8 245.8-126.6 6-6.1 12.1-12.6 18.2-19.4l70.3-8C822.3 910.9 693.1 985.9 549.1 1000l23.3-53.7z",
    fill: "url(#iris_svg__c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iris_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 324.472,
    y1: 1130.878,
    x2: 1104.452,
    y2: 350.898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3554"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M921 660.3c19.2-51.1 29-105 29-160.3 0-48.8-7.7-96.8-22.8-142.6l28.2-65C985 357.7 1000 427.5 1000 500c0 72.4-15 142.1-44.5 207.4L921 660.3z",
    fill: "url(#iris_svg__d)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iris_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: -130.928,
    y1: 675.477,
    x2: 649.053,
    y2: -104.502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3554"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 708.1C15.1 642.6 0 572.7 0 500c0-73.1 15.2-143.4 45.3-209.1l34.4 47C60 389.5 50 444 50 500c0 49 7.7 97.1 22.9 143.1l-28.1 65z",
    fill: "url(#iris_svg__e)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iris_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: -210.017,
    y1: 596.388,
    x2: 569.963,
    y2: -183.592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3554"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6 204.6C180.2 87.8 308.6 13.8 451.3 0L428 53.6c-93.5 15-178.6 58.8-246.2 126.7-5.1 5.1-10.2 10.6-15.3 16.2l-70.9 8.1z",
    fill: "url(#iris_svg__f)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iris_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 12.497,
    y1: 818.902,
    x2: 792.477,
    y2: 38.923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3554"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M848.6 214c-9.6-11.8-19.8-23.1-30.4-33.7C755.4 117.2 676.8 74.6 590.7 57L548.8 0c143.9 14 273.1 88.9 357.7 207.5l-57.9 6.5z",
    fill: "url(#iris_svg__g)"
  })));
}

export default SvgIris;